
import { MDBContainer, MDBRow, MDBCol, MDBIcon, MDBBtn } from 'mdb-react-ui-kit';
import React from 'react';
import ScrollTo from "react-scroll-into-view";
import './App.css';
import {sections} from './data/sections';

function App() {
  return (
    <MDBContainer fluid className="App">

        {
          sections.map((section, sectionIndex) => {
            const {id, subtitle, title, description, img, hasTwoButtons, selectors} = section;

            return (
              <MDBRow key={id} id={id} className="row d-flex justify-content-center align-items-center section-full-frame section-fixed-effect section-backgroung-cover" style={{ backgroundImage: `url(assets/bg-effect.svg), linear-gradient(45deg, rgba(0,0,0,0.329) 22%, rgba(196,123,82,0.541) 100%), url(${img})` }}>
                <MDBCol className="col-sm-12 text-center d-flex flex-column justify-content-center align-items-center align-self-stretch mb-0 black p-5">
                    <span className="text-white style1 mb-4">{subtitle}</span>
                    <h1 className="my-4 section-font text-center text-white style2">{title}</h1>
                    <p className="text-white w-50 style3">{description}</p>
                    <div className="d-flex flex-row justify-content-center align-items-center">
                          {
                            hasTwoButtons ? (
                              <React.Fragment>
                                    <ScrollTo selector={selectors[0]}>
                                        <MDBBtn floating className="my-4 mx-3 nav-button">
                                            <MDBIcon fas icon="arrow-up" size='3x mt-1' className="text-white"/>
                                        </MDBBtn>
                                    </ScrollTo>
                                    <ScrollTo selector={selectors[1]}>
                                        <MDBBtn floating className="my-4 mx-3 nav-button">
                                            <MDBIcon fas icon="arrow-down" size='3x mt-1' className="text-white"/>
                                        </MDBBtn>
                                    </ScrollTo> 
                              </React.Fragment>
                              )
                          : (
                                <ScrollTo selector={selectors[0]}>
                                  <MDBBtn floating className="my-4 nav-button">
                                      <MDBIcon fas icon={sectionIndex === sections.length-1 ? 'arrow-up' : 'arrow-down'} size='3x mt-1' className="text-white"/>
                                  </MDBBtn>
                                </ScrollTo> 
                          )
                        }
                    </div>  
                </MDBCol>
              </MDBRow>
            )
            
            
          })
        }

    </MDBContainer>
  );
}

export default App;
